import {global} from "./Global";

export async function postData(url = '', data = {}) {
	const response = await fetch(url, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
		body: data
	});

	if (response.status >= 500) {
		const unexpectedErrorText = '<ul class="woocommerce-error" role="alert"><li>Klaida. Pabandykite vėliau.</li></ul>';

		global.appendNotice(unexpectedErrorText);

		return false;
	}

	if (response.status >= 400 && response.error) {
		console.error(response.error)
	}

	let responseBody = await response.json();

	if (responseBody.error) {
		console.log(responseBody.message)
	}

	if (responseBody.notice) {
		global.appendNotice(responseBody.notice);
	}

	if (!responseBody || responseBody === -1) {
		return false;
	}

	return responseBody;
}
